export default {
  subjectSearch: [],
  skillDescription: {
    hover: false,
    click: false,
    title: '',
    description: '',
    position: {},
  },
  highlightedAnnotation: {
    hover: null,
    click: null,
  },
};
